"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentUrlUploadPreparator", {
    enumerable: true,
    get: function() {
        return AttachmentUrlUploadPreparator;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Jobs = require("~/interface/Jobs");
const _constants = require("~/constants");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _dbHelpers = require("~/helpers/dbHelpers");
const _models = require("~/models");
const _NcPluginMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/helpers/NcPluginMgrv2"));
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _extractProps = require("~/helpers/extractProps");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let AttachmentUrlUploadPreparator = class AttachmentUrlUploadPreparator {
    async prepareAttachmentUrlUpload(baseModel, { attachmentCols, data, req }) {
        const postInsertOps = [];
        const preInsertOps = [];
        const postInsertAuditOps = [];
        // return early if not v3
        if (baseModel.context.api_version !== _nocodbsdk.NcApiVersion.V3) {
            return {
                postInsertOps,
                preInsertOps,
                postInsertAuditOps
            };
        }
        for (const col of attachmentCols){
            let attachmentData;
            try {
                var _ref;
                const attachmentDataRaw = (0, _dbHelpers.dataWrapper)(data).getByColumnNameTitleOrId(col);
                if (!attachmentDataRaw) {
                    continue;
                }
                attachmentData = (_ref = typeof attachmentDataRaw === 'string' ? JSON.parse(attachmentDataRaw) : attachmentDataRaw) != null ? _ref : [];
                if (attachmentData.length === 0) {
                    continue;
                }
            } catch (unused) {
                continue;
            }
            // only process when temp id exists
            if (attachmentData.some((attr)=>{
                var _attr_id;
                return (_attr_id = attr.id) == null ? void 0 : _attr_id.startsWith('temp_');
            })) {
                const storageAdapter = await _NcPluginMgrv2.default.storageAdapter();
                attachmentData = await Promise.all(attachmentData.map(async (attr)=>{
                    var _attr_id;
                    if ((_attr_id = attr.id) == null ? void 0 : _attr_id.startsWith('temp_')) {
                        var _uploadedPath_url, _ref;
                        var _req_user;
                        const filePaths = (0, _attachmentHelpers.constructFilePath)(baseModel.context, _extends({
                            columnId: col.id,
                            modelId: baseModel.model.id,
                            scope: undefined
                        }, (0, _attachmentHelpers.getFileNameFromUrl)({
                            url: attr.url,
                            scope: undefined
                        })));
                        const uploadedPath = storageAdapter.getUploadedPath(filePaths.storageDest);
                        const id = await _models.FileReference.insert(baseModel.context, {
                            storage: storageAdapter.name,
                            // currently a placeholder
                            // it will be replaced after upload success
                            file_url: (_uploadedPath_url = uploadedPath.url) != null ? _uploadedPath_url : uploadedPath.path,
                            file_size: null,
                            fk_user_id: (_ref = req == null ? void 0 : (_req_user = req.user) == null ? void 0 : _req_user.id) != null ? _ref : 'anonymous',
                            source_id: baseModel.model.source_id,
                            fk_model_id: baseModel.model.id,
                            fk_column_id: col.id,
                            is_external: !(await baseModel.getSource()).isMeta(),
                            deleted: true
                        });
                        return _extends({
                            id,
                            url: attr.url,
                            status: 'uploading'
                        }, filePaths);
                    } else {
                        return attr;
                    }
                }));
                postInsertOps.push(async (recordId)=>{
                    _Noco.default.eventEmitter.emit(_constants.EMIT_EVENT.HANDLE_ATTACHMENT_URL_UPLOAD, {
                        jobName: _Jobs.JobTypes.AttachmentUrlUpload,
                        context: baseModel.context,
                        modelId: baseModel.model.id,
                        column: col,
                        recordId,
                        user: baseModel.context.user,
                        attachments: attachmentData,
                        req: {
                            context: baseModel.context,
                            user: req.user
                        }
                    });
                    return '';
                });
                const columnKeyName = (0, _dbHelpers.dataWrapper)(data).getColumnKeyName(col);
                // remove temp_ ids so it doesn't get recorded in audit
                data[columnKeyName] = JSON.stringify(attachmentData.map((attr)=>{
                    if (!('status' in attr)) {
                        return attr;
                    }
                    return (0, _extractProps.extractProps)(attr, [
                        'id',
                        'url',
                        'status',
                        'type'
                    ]);
                }));
            }
        }
        return {
            postInsertOps,
            preInsertOps,
            postInsertAuditOps
        };
    }
};
